/**
 * Bootstrap modal that opens automatically and closes on successful form submission.
 */
import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static get targets() {
    return ["autofocus"];
  }

  connect() {
    this.modal = new Modal(this.element);
    this.modal.show();

    if (this.hasAutofocusTarget) {
      // Focus once Bootstrap's own open transition actually finishes, instead of
      // guessing with a fixed timeout that can fire mid-typing on slower CI runners.
      this.element.addEventListener(
        "shown.bs.modal",
        () => {
          // Don't steal focus if the user has already interacted with the form.
          if (document.activeElement && document.activeElement !== document.body) return;

          this.autofocusTarget.focus();
          if (this.autofocusTarget.setSelectionRange) {
            this.autofocusTarget.setSelectionRange(-1, -1);
          } else if (this.autofocusTarget.editor && this.autofocusTarget.editor.setSelectedRange) {
            // Trix Editor
            this.autofocusTarget.editor.setSelectedRange(
              this.autofocusTarget.editor.getDocument().toString().length - 1,
            );
          }
        },
        { once: true },
      );
    }
  }

  hideBeforeRender(event) {
    if (event.detail.success && this.isOpen()) {
      event.preventDefault();
      this.element.addEventListener("hidden.bs.modal", event.detail.resume);
      this.modal.hide();
    }
  }

  isOpen() {
    return this.element.classList.contains("show");
  }

  close() {
    this.modal.hide();
  }

  disconnect() {
    this.modal.dispose();
  }
}
